import { SelectionBox, Shape, ShapeType } from '../../model/types';

const isPointInsideSelection = (x: number, y: number, selectionBox: SelectionBox): boolean => {
  return (
    x >= selectionBox.x && x <= selectionBox.x + selectionBox.width && y >= selectionBox.y && y <= selectionBox.y + selectionBox.height
  );
};

const isBoundsIntersectingSelection = (
  bounds: { x: number; y: number; width: number; height: number },
  selectionBox: SelectionBox,
): boolean => {
  const x1 = bounds.x;
  const x2 = bounds.x + bounds.width;
  const y1 = bounds.y;
  const y2 = bounds.y + bounds.height;
  const sx1 = selectionBox.x;
  const sx2 = selectionBox.x + selectionBox.width;
  const sy1 = selectionBox.y;
  const sy2 = selectionBox.y + selectionBox.height;

  return x1 <= sx2 && x2 >= sx1 && y1 <= sy2 && y2 >= sy1;
};

export const isShapeInSelection = (shape: Shape, selectionBox: SelectionBox): boolean => {
  if (shape.type === ShapeType.POLYGON || shape.type === ShapeType.LINE || shape.type === ShapeType.POLYGON_BOX) {
    for (let i = 0; i < shape.points.length; i += 2) {
      if (isPointInsideSelection(shape.points[i], shape.points[i + 1], selectionBox)) {
        return true;
      }
    }
    return false;
  }

  if (shape.type === ShapeType.RECTANGLE) {
    return isBoundsIntersectingSelection(
      {
        x: shape.x,
        y: shape.y,
        width: shape.width,
        height: shape.height,
      },
      selectionBox,
    );
  }

  if (shape.type === ShapeType.CIRCLE) {
    return isBoundsIntersectingSelection(
      {
        x: shape.x - shape.radiusX,
        y: shape.y - shape.radiusY,
        width: shape.radiusX * 2,
        height: shape.radiusY * 2,
      },
      selectionBox,
    );
  }

  return isPointInsideSelection(shape.x, shape.y, selectionBox);
};
